// extracted by mini-css-extract-plugin
export var accent = "_2n-4";
export var add = "_2n-j";
export var addIcon = "_2n-k";
export var deleteIcon = "_2n-i";
export var disabled = "_2n-9";
export var ellipsis = "_2n-f";
export var error = "_2n-3";
export var form = "_2n-5";
export var hideFocus = "_2n-2";
export var icon = "_2n-7";
export var input = "_2n-e";
export var listItem = "_2n-h";
export var mediumHeight = "_2n-b";
export var noBorder = "_2n-8";
export var noRadius = "_2n-1";
export var shortHeight = "_2n-a";
export var tallHeight = "_2n-c";
export var textInput = "_2n-0";
export var vertical = "_2n-g";
export var veryTallHeight = "_2n-d";
export var widget = "_2n-6";